var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-module',{attrs:{"module":_vm.module}},[(_vm.hasRights)?_c('router-view',{attrs:{"slot":"body"},slot:"body"}):_c('div',{attrs:{"slot":"body"},slot:"body"},[_c('ModuleUpgrade')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }